import styled from 'styled-components'

export const Container = styled.div`
    display: grid;
    grid-template-columns: 200px 1fr;
    grid-template-rows: 47px 1fr;
    grid-template-areas:
        'menu header'
        'menu main';
    height: 100vh;
    transition: all 0.3s ease-out;
    overflow: hidden;

    &.close {
        /* grid-template-columns: 200px 1fr; */
        margin-left: -200px;
        @media (min-width: 1440px) {
            /* margin-left: -250px; */
        }
    }

    main {
        grid-area: main;
        /* padding: 20px; */
        overflow-y: auto;
        overflow-x: hidden;
    }

    @media (min-width: 678px) {
        grid-template-columns: 60px 1fr;

        &.open {
            grid-template-columns: 200px 1fr;
        }

        &.close {
            margin-left: 0;
        }
    }

    @media (min-width: 1440px) {
        grid-template-columns: 60px 1fr;

        &.open {
            grid-template-columns: 250px 1fr;
        }

        &.close {
            margin-left: 0;
        }
    }
`
